import React, { useState, useEffect, useCallback } from 'react';
import { Card, DatePicker, Button, Table, Statistic, Row, Col, Tag, message } from 'antd';
import dayjs from 'dayjs';
import { getFinanceReport } from '../../api/reports';
import { formatMoney } from '../../utils/money';
import { dateSorter, numberSorter, textSorter } from '../../utils/tableSorters';

const { RangePicker } = DatePicker;

const FinanceReportTab = () => {
  const [range, setRange] = useState([dayjs().startOf('month'), dayjs()]);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetch = useCallback(async () => {
    if (!range) return;
    setLoading(true);
    try {
      const res = await getFinanceReport({
        start_date: range[0].format('YYYY-MM-DD'),
        end_date:   range[1].format('YYYY-MM-DD'),
      });
      setData(res.data);
    } catch {
      message.error('Finansal rapor yüklenemedi.');
    } finally {
      setLoading(false);
    }
  }, [range]);

  useEffect(() => { fetch(); }, []);

  // Liste tarih+yontem bazinda agrege geliyor ve tamami bellekte - istemci
  // siralayicilari dogru sonuc verir.
  const columns = [
    {
      title: 'Tarih',
      dataIndex: 'date',
      sorter: dateSorter('date'),
      render: v => dayjs(v).format('DD.MM.YYYY'),
    },
    {
      title: 'Yöntem',
      dataIndex: 'payment_method',
      sorter: textSorter('payment_method'),
      render: v => {
        const map = { cash: ['green', 'Nakit'], transfer: ['blue', 'Havale/EFT'], credit_card: ['purple', 'Kredi Kartı'], other: ['default', 'Diğer'] };
        const [color, label] = map[v] || ['default', v];
        return <Tag color={color}>{label}</Tag>;
      },
    },
    {
      title: 'Tutar',
      dataIndex: 'total',
      align: 'right',
      render: v => <span className="font-medium">{formatMoney(v)}</span>,
      sorter: numberSorter('total'),
    },
  ];

  return (
    <div>
      <div className="flex items-center gap-3 mb-4">
        <RangePicker value={range} onChange={setRange} format="DD.MM.YYYY" />
        <Button type="primary" onClick={fetch} loading={loading}>Getir</Button>
      </div>

      {data && (
        <>
          <Row gutter={16} className="mb-4">
            <Col span={6}>
              <Card size="small">
                <Statistic
                  title="Toplam Tahsilat"
                  value={parseFloat(data.total_collected).toFixed(2)}
                  suffix="₺"
                  valueStyle={{ color: '#52c41a' }}
                />
              </Card>
            </Col>
            <Col span={6}>
              <Card size="small">
                <Statistic title="Nakit" value={parseFloat(data.total_cash).toFixed(2)} suffix="₺" />
              </Card>
            </Col>
            <Col span={6}>
              <Card size="small">
                <Statistic title="Havale/EFT" value={parseFloat(data.total_transfer).toFixed(2)} suffix="₺" />
              </Card>
            </Col>
            <Col span={6}>
              <Card size="small">
                <Statistic
                  title="Toplam Alacak"
                  value={parseFloat(data.total_debt).toFixed(2)}
                  suffix="₺"
                  valueStyle={{ color: '#ff4d4f' }}
                />
              </Card>
            </Col>
          </Row>

          <Table
            dataSource={data.payments}
            rowKey={(r, i) => `${r.date}-${r.payment_method}-${i}`}
            columns={columns}
            size="small"
            pagination={{ pageSize: 20 }}
          />
        </>
      )}
    </div>
  );
};

export default FinanceReportTab;
